require('./builder').setDefaultConfig({
  'elements': {
    'text': {
      'element_class': 'cloud-control form-control',
      'wrap_class': 'cloud-group',
      'label_class': 'cloud-label',
    },
    'textarea': {
      'element_class': 'cloud-control',
      'wrap_class': 'cloud-group',
      'label_class': 'cloud-label',
    },
    'password': {
      'element_class': 'cloud-control form-control',
      'wrap_class': 'cloud-group',
      'label_class': 'cloud-label',
    },
    'radio': {
      'wrap_class': 'cloud-group',
      'label_class': 'cloud-form-control cloud-radio',
    },
    'checkbox': {
      'wrap_class': 'cloud-group',
      'label_class': 'cloud-form-control cloud-checkbox',
    },
    'switch': {
      'wrap_class': 'cloud-group',
      'label_class': 'cloud-form-control',
    },
    'select': {
      'wrap_class': 'cloud-group',
    },
    'social': {
      'wrap_class': 'cloud-group',
      'label_class': 'cloud-form-control',
    },
    'textButton': {
      'element_class': 'cloud-control',
      'wrap_class': 'cloud-group',
      'label_class': 'cloud-label',
    },
    'datetimepicker': {
      'element_class': 'cloud-control form-control',
      'wrap_class': 'cloud-group',
      'label_class': 'cloud-label',
    },
    'selectTag': {
      'element_class': 'cloud-control form-control',
      'wrap_class': 'cloud-group',
      'label_class': 'cloud-label',
    },
    'url': {
      'element_class': 'cloud-control form-control',
      'wrap_class': 'cloud-group',
      'label_class': 'cloud-label',
    },
  },
});
